import type { ActiveBasketSummaryData } from '../../typings/basket.types';
import type { ApplePayShippingMethod } from '../../typings/apple.types';

const calculateTotalPrice = (
    basket: ActiveBasketSummaryData,
    selectedShippingMethod?: ApplePayShippingMethod,
): number => {
    const shippingTax = selectedShippingMethod ? parseFloat(selectedShippingMethod.tax) : 0;
    const shippingAmount =
        selectedShippingMethod?.amount ? parseFloat(selectedShippingMethod.amount) : 0;

    return basket.totalItemPrice + shippingTax + shippingAmount + basket.promoTotal;
};

export default calculateTotalPrice;
